const PLUS_COLORS = [
    "#303C42",
    //"#00a4cf",
    //"#44719D",
    "#8E6C88",
    "#FF5757",
    "#FE814C",
    "#24A18E",
    "#5db4c0"];


export default PLUS_COLORS;